import copy from 'copy-to-clipboard';

const hashNavigate = (anchor: string): void => {
  if (window.location.hash !== `#${anchor}`) {
    history.pushState(null, '', `#${anchor}`);
    const urlWithHash = `${window.location.origin}${window.location.pathname}#${anchor}`;
    copy(urlWithHash);
  }

  const element = document.getElementById(anchor);
  const scrollOffset = getScrollOffset();
  if (element) {
    const elementRect = element.getBoundingClientRect();
    const topPosition = elementRect.top + window.scrollY - scrollOffset;
    window.scrollTo({ top: topPosition, behavior: 'instant' });
  }
};

export const getScrollOffset = () => {
  let offset = 8;
  const header = document.getElementById('developer-studio-header')?.offsetHeight || 0;
  const headerMobile = document.getElementById('developer-studio-header-mobile')?.offsetHeight || 0;
  offset += header + headerMobile;

  const languageHeader = document.getElementById('language-selector');
  if (languageHeader) {
    const languageHeaderOffset = languageHeader.offsetHeight || 0;
    offset += languageHeaderOffset;
  }
  return offset;
};

export default hashNavigate;
